module.exports = __webpack_public_path__ + "img/icon_ndf.96c0f738.png";